<button mat-raised-button
  class="jafar-action-button"
  color="primary"
  (click)="onClick()"
  [disabled]="disabled">
  <ng-content></ng-content>
</button>
